export const BREAK_POINT_SM = '768px';
export const BREAK_POINT_M = '900px';
export const BREAK_POINT_L = '1080px';
export const BREAK_POINT_XL = '1200px';
export const BREAK_POINT_XXL = '1400px';
